module.exports = __webpack_public_path__ + "media/components/Builder/Library/Modules/Page/Thumbnails/Reusable-ab7f6cd9437173aec4f08e7644f3aca1.png";